import MapView from '../components/MapView';
import { useEffect, useState } from 'react';
import api from '../lib/api';
import { Link } from 'react-router-dom';
import { Calendar, MapPin } from '@phosphor-icons/react';
import Seo from '../components/Seo';

export default function MapPage() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get('/events?limit=500').then(r => setEvents(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Seo
        path="/map"
        title="Pow Wow Map"
        description="Interactive map of every upcoming Native American & First Nations pow wow across the US and Canada. Click any marker for event details, dance categories, prize payouts, and nearby lodging."
        keywords="pow wow map, powwow near me, native american event map, indigenous gathering map"
      />
      <p className="label text-terracotta mb-2">Map</p>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-6">Pow wows across Turtle Island</h1>
      <div className="grid lg:grid-cols-[1fr_320px] gap-6">
        <div className="bg-card border border-border rounded-2xl p-3">
          <MapView events={events} height="75vh" zoom={4} />
        </div>
        <aside className="space-y-3 lg:max-h-[75vh] lg:overflow-y-auto pr-1">
          {events.map(e => (
            <Link key={e.event_id} to={`/events/${e.event_id}`} className="block bg-card border border-border rounded-xl p-4 hover:border-terracotta transition-colors" data-testid={`map-list-${e.event_id}`}>
              <p className="label text-terracotta mb-1">{e.tribe}</p>
              <p className="font-display text-lg leading-tight">{e.name}</p>
              <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1"><Calendar size={12} /> {e.start_date}</p>
              <p className="text-xs text-muted-foreground flex items-center gap-1"><MapPin size={12} /> {e.city}, {e.state}</p>
            </Link>
          ))}
        </aside>
      </div>
    </div>
  );
}
